import { Box } from '@mui/material'
import AiAskBarDictationWaveformRow from './AiAskBarDictationWaveformRow'
import AiAskBarHomeComposerEditor from './AiAskBarHomeComposerEditor'
import AiAskBarHomeRightActions from './AiAskBarHomeRightActions'
import AiAskBarLandingLeftActions from './AiAskBarLandingLeftActions'
import AiAskBarLeftActions from './AiAskBarLeftActions'
import styles from './index.module.scss'

export default function AiAskBarHomeMainGrid({ vm, actions, sendDisabled, onVoiceToggle, voiceActive, model, onModelChange, landing = false, showSelects = true }) {
  const gridClassName = [
    styles.mainInputGrid,
    vm.isExpanded ? styles.mainInputGridExpanded : '',
    landing ? '' : styles.mainInputGridCompact,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Box className={gridClassName}>
      <AiAskBarHomeComposerEditor
        composerEditorRef={vm.composerEditorRef}
        inputPlaceholder={vm.inputPlaceholder}
        isDictating={vm.isDictating}
        isExpanded={vm.isExpanded}
        textareaMaxHeightPx={vm.textareaMaxHeightPx}
        setComposerPlainText={vm.setComposerPlainText}
        handleComposerEnter={actions.handleComposerEnter}
      />
      {landing ? (
        <AiAskBarLandingLeftActions vm={vm} actions={actions} showPersona={showSelects} />
      ) : (
        <AiAskBarLeftActions
          showAttach
          showConnections
          connectionsButtonRef={vm.connectionsButtonRef}
          setConnectionsOpen={vm.setConnectionsOpen}
          attachments={vm.attachments}
          handleOpenFilePicker={actions.handleOpenFilePicker}
          onSelectFromDocuments={actions.handleOpenDocumentsPicker}
        />
      )}
      <AiAskBarDictationWaveformRow
        isDictating={vm.isDictating}
        levels={vm.levels}
        minBarPx={vm.minBarPx}
        maxBarPx={vm.maxBarPx}
      />
      <AiAskBarHomeRightActions vm={vm} actions={actions} sendDisabled={sendDisabled} onVoiceToggle={onVoiceToggle} voiceActive={voiceActive} model={model} onModelChange={onModelChange} landing={landing} showModelSelect={showSelects} />
    </Box>
  )
}
